<template>
  <div class="radioTitle">
    {{ content }}
    <span v-if="isRequired" class="required">*</span>
  </div>
  <el-radio-group v-model="selectedOption" @change="onChange">
    <el-radio
      v-for="option in options"
      :key="option.value"
      :label="option.value"
      border
      :disabled="this.disabled"
    >
      {{ option.label }}
    </el-radio>
  </el-radio-group>
</template>

<script>
export default {
  name: "QuestionnaireRadio",
  props: {
    isRequired: {
      type: Boolean,
    },
    content: {
      type: String,
      required: true,
    },
    height: {
      type: String,
    },
    width: {
      type: String,
    },
    options: {
      type: Array,
      required: true,
    },
    value: {
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        this.selectedOption = newValue;
      },
    },
  },
  emits: ["onChange"],
  data() {
    return {
      selectedOption: this.value,
      radioHeight: this.height === "tall" ? "80px" : "42px",
      radioWidth: this.width === "wide" ? "27vw" : "18vw",
    };
  },
  methods: {
    onChange() {
      this.$emit("onChange", this.selectedOption);
    },
  },
};
</script>

<style scoped>
.radioTitle {
  font-size: 16px;
  font-weight: 600;
  line-height: 19px;
  letter-spacing: 0.175px;
  margin-bottom: 8px;
}

.required {
  color: #ff1d00;
}

.el-radio-group {
  display: flex;
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
  justify-content: space-between;
  flex-wrap: wrap;
}

:deep(.el-radio.is-bordered) {
  width: v-bind("radioWidth");
  /* min-width: 284px; */
  min-height: v-bind("radioHeight");
  height: fit-content;
  border-radius: 4px;
  border: 1px solid #bcccdc;
  margin-bottom: 10px;
  margin-right: 0px;
}

:deep(.el-radio__label) {
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0.46px;
  color: #000000;
  white-space: normal;
}

:deep(.el-radio.is-bordered.is-checked) {
  border: 1px solid #20a8c3;
  background-color: rgba(32, 168, 195, 0.1);
}

:deep(.el-radio__input.is-checked + .el-radio__label) {
  font-weight: 500;
  color: #20a8c3;
}

:deep(.el-radio__inner) {
  height: 20px !important;
  width: 20px !important;
  margin-left: 23px;
  margin-right: 23px;
  border: 2px #000000 solid;
}

:deep(.el-radio__input.is-disabled .el-radio__inner) {
  border: 2px #bcccdc solid;
  background: transparent !important;
}

:deep(.el-radio__input.is-checked .el-radio__inner) {
  border: 2px #20a8c3 solid !important;
  background: transparent !important;
}

:deep(.el-radio__input.is-checked .el-radio__inner::after) {
  content: "";
  display: block;
  width: 10px;
  height: 10px;
  background-color: #20a8c3;
  border-radius: 50%;
  box-sizing: border-box;
  border: 2px #20a8c3 solid !important;
}

.menstrualPhaseRadio .el-radio-group .el-radio.is-bordered:nth-child(5) {
  width: 56vw !important;
}
.menstrualPhaseRadio .el-radio-group .el-radio.is-bordered:nth-child(6) {
  width: 56vw !important;
}

@media only screen and (max-width: 1024px) {
  .el-radio-group {
    flex-direction: column;
  }
  :deep(.el-radio.is-bordered) {
    width: 100%;
    min-height: 42px;
    height: fit-content;
  }

  .radioTitle {
    font-size: 14px;
  }

  :deep(.el-radio__label) {
    font-size: 14px;
  }

  .menstrualPhaseRadio .el-radio-group .el-radio.is-bordered:nth-child(5) {
    width: 100% !important;
  }
  .menstrualPhaseRadio .el-radio-group .el-radio.is-bordered:nth-child(6) {
    width: 100% !important;
  }

  .el-radio div {
    font-size: 14px !important;
    font-weight: 400 !important;
  }

  :deep(.el-radio__inner) {
    height: 16px !important;
    width: 16px !important;
    margin-left: 12px;
    margin-right: 12px;
    border: 1px #000000 solid !important;
  }

  :deep(.el-radio__input.is-checked .el-radio__inner::after) {
    width: 8px;
    height: 8px;
    border: 1px #20a8c3 solid !important;
  }
}
</style>
